import { render, staticRenderFns } from "./PreviousSoloRatings.vue?vue&type=template&id=091f1c7a&scoped=true&"
import script from "./PreviousSoloRatings.vue?vue&type=script&lang=js&"
export * from "./PreviousSoloRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091f1c7a",
  null
  
)

export default component.exports